import { render } from "./CheckoutLightStep.vue?vue&type=template&id=334577aa&scoped=true"
import script from "./CheckoutLightStep.vue?vue&type=script&lang=js"
export * from "./CheckoutLightStep.vue?vue&type=script&lang=js"

import "./CheckoutLightStep.vue?vue&type=style&index=0&id=334577aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334577aa"]])

export default __exports__